import { TIcon } from '../../svg/icons';
import { BreakpointCustomizable, color } from '../../utils';
import { ICONSMANIFEST } from '../../svg/icons';

const ICONS_BASE_URL = 'https://dc-webtoolkit.azureedge.net/icons/';
const DEFAULT_ICON_NAME = 'home';
const requestCache = new Map<string, Promise<string>>(); // Initialize a map to store previously made requests

export const isUrl = (str: string): boolean => str?.length > 0 && /(\/)/.test(str);

export const getSvgContent = async (url: string): Promise<string> => {
  if (!url) {
    // check if the input url is undefined
    return Promise.reject('url is undefined'); // return rejected promise if undefined
  }

  let req = requestCache.get(url); // check if there is a request in the cache for the input url
  if (req === undefined) {
    // if not
    req = fetch(url).then(
      // make a new request
      (rsp) => (rsp.ok ? rsp.text() : ''), // if the request is ok, return the text content of the response
      () => '' // if the request fails, return empty string
    );
    requestCache.set(url, req); // add the new request to the cache
  }

  return req; // return the request
};

export const cleanSVG = (svg: string): string => {
  // remove title tag from svg
  const titleRegex = /<title>.*<\/title>/g;
  const cleanedSVG = svg.replace(titleRegex, '');
  // remove comments from svg
  const commentRegex = /<!--.*-->/g;
  return cleanedSVG.replace(commentRegex, '');
};

export const buildIconUrl = (iconNameOrUrl: TIcon | string = DEFAULT_ICON_NAME): string => {
  if (iconNameOrUrl === null) {
    return buildIconUrl(DEFAULT_ICON_NAME);
  } else if (isUrl(iconNameOrUrl)) {
    return iconNameOrUrl;
  } else if (ICONSMANIFEST[iconNameOrUrl]) {
    return `${ICONS_BASE_URL}${ICONSMANIFEST[iconNameOrUrl]}`;
  }
};

export const ICON_COLORS = {
  inherit: 'inherit',
  currentColor: 'currentColor',
  ...color,
};
export const IconColors = Object.keys(ICON_COLORS);
export type IconColors = keyof typeof ICON_COLORS;
export type TIconColors = BreakpointCustomizable<IconColors>;

export const ICON_SIZE = {
  tiny: 16,
  small: 20,
  medium: 24,
  large: 32,
};
export const IconsSizes = Object.keys(ICON_SIZE);
export type IconSize = keyof typeof ICON_SIZE;
export type TIconSize = BreakpointCustomizable<IconSize>;
